export const useDisplayPreviousMonthCalendar =
  ({ monthStateHandler, yearStateHandler }) =>
  ({ calendarCurrentMonth, calendarCurrentYear }) => {
    let previousMonth = calendarCurrentMonth - 1;
    if (previousMonth === -1) {
      previousMonth = 11;
      yearStateHandler(calendarCurrentYear - 1);
    }
    monthStateHandler(previousMonth);
  };
